import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchPacks(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/generator/packs', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPackDetails(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/generator/packs/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadPack(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/generator/packs/${id}/download`, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
